import '@core/api';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { getMissionChartData, type MissionChartPoint } from '@wwf/sdk';

export const missionChartQueryKey = ['missionChartData'] as const;

export const useMissionChartData = (): UseQueryResult<
    MissionChartPoint[],
    Error
> =>
    useQuery({
        queryKey: missionChartQueryKey,
        queryFn: () => getMissionChartData(),
    });
